'use strict';

import jQuery from 'jquery';
import cookie from './../../../vendor/jquery.cookie';
import Core from './../../Core/Core';
import heroSlider from './../../HeroSlider/heroSlider';
import AlphabeticalList from '../../AlphabeticalListPage/AlphabeticalList.js';
import resourceTemplate from './views/resource.hbs';

/**
 * Page
 *
 * JavaScript functions for the Page page
 */
var Page = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      fromCookie: false,
      $clonedDisciplines: null,
      $ajaxOverlay: $('#ajax-loader-overlay'),
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the blocks on the page
      privateNS.$blocks = privateNS.$container.find('.block');

      // Create a reference to the tab controls
      privateNS.$tabControls = privateNS.$container.find('.page-tab');

      // Create a reference to the tab contents
      privateNS.$tabContents = privateNS.$container.find('.page-tab-content');
      
      // Add the alphabetical list if there is one, as well as the discipline filtering.
      privateNS.$alphabeticalContainer = privateNS.$container.find('.list-alphabetical');

      if (privateNS.$alphabeticalContainer.length > 0) {
        privateNS.alphabeticalList = new AlphabeticalList({
          container: '#page'
        });

        // Set up the switching between the filters.
        privateNS.$disciplineContainer = privateNS.$container.find('.discipline-container');
        privateNS.$filterByLetter = privateNS.$container.find('.filter-by-letter');
        privateNS.$filterByDiscipline = privateNS.$container.find('.filter-by-discipline');

        privateNS.$filterByLetter.click(function(e) {
          privateNS.$alphabeticalContainer.show();
          privateNS.$disciplineContainer.hide();
          $.cookie('profiles_filter', 'filter-by-letter');
        });

        privateNS.$filterByDiscipline.click(function(e) {
          privateNS.$alphabeticalContainer.hide();
          privateNS.$disciplineContainer.show();
          $.cookie('profiles_filter', 'filter-by-discipline');
        });

        // Set up the radio selection.
        privateNS.$disciplineItemsContainer =  privateNS.$disciplineContainer.find('.profiles-by-discipline-container');
        privateNS.$disciplineList = privateNS.$disciplineContainer.find('.full-profiles-by-discipline-list');
        privateNS.$disciplineItems = privateNS.$disciplineList.find('li');
        privateNS.$disciplineContainer.find('.radio-item input').click(function(e) {

          // Move to after "radio-item-".
          var disciplineId = $(this).attr('id').substr(11);
          
          $.cookie('selected_discipline', disciplineId);

          // Because we are using block grid here, we need to build a DOM with only the elements that
          // will be shown and append it.
          
          // Remove any previous clone.
          if (privateNS.$clonedDisciplines !== null) {
            privateNS.$clonedDisciplines.remove();
          }

          privateNS.$clonedDisciplines = $('.full-profiles-by-discipline-list').clone();
          privateNS.$clonedDisciplines.find('li').each(function(i, el) {
            var $el = $(el),
              disciplines = $el.attr('data-disciplines').split(' '),
              keepDiscipline = false;

            disciplines.forEach(function(discipline) {
              if (discipline === disciplineId) {
                keepDiscipline = true;
              }
            });

            if (!keepDiscipline) {
              $el.remove();
            }
          });

          // Remove the class that hides the full one.
          privateNS.$clonedDisciplines.removeClass('full-profiles-by-discipline-list');

          privateNS.$disciplineItemsContainer.append(privateNS.$clonedDisciplines);
          
          // Don't scroll when coming from the cookie, because the browser does this for us.
          if (privateNS.fromCookie) {
            privateNS.fromCookie = false;
          } else {
            $('html, body').animate({scrollTop: (privateNS.$clonedDisciplines.offset().top - privateNS.$container.offset().top) + 'px'});
          }
        });

        // Set up initial state.
        var profilesFilter = $.cookie('profiles_filter');

        if (typeof profilesFilter === 'undefined') {

          // Default to filter by letter.
          privateNS.$filterByLetter.trigger('click');
        } else {
          $('.' + profilesFilter).trigger('click');

          // Set up the appropriate discipline if selected.
          var selectedDiscipline = $.cookie('selected_discipline');

          if (typeof selectedDiscipline !== 'undefined') {
            privateNS.fromCookie = true;
            privateNS.$disciplineContainer.find('#radio-item-' + selectedDiscipline).trigger('click');
          }
        }
      }

      // Check for resource setup.
      var $resourcesContainer = privateNS.$container.find('.resources');

      if ($resourcesContainer.length > 0) {
        var $resources = $resourcesContainer.find('ul'),
          $disciplines = $('.disciplines'),
          $diversities = $('.diversities'),
          $allResources,
          resourceItemsLength,
          shownResources,
          totalResources,
          allResourcesLoaded = false;

        // Get the rest of the resources and append them.
        $.get(window.themosis.ajaxurl, {
          action: 'Resource.getExtra',
          property_id: $('.property-id').val()
        })
        .then(function(data) {
          var $resourcesMarkup = $('<ul></ul>');

          $.parseJSON(data).forEach(function(resource) {
            $resourcesMarkup.append(resourceTemplate({resource: resource}));
          });

          $('.resources-list').append($resourcesMarkup.html());
          $allResources = $resources.clone();
          resourceItemsLength = $allResources.find('li').length;
          shownResources = resourceItemsLength > 6 ? 6 : resourceItemsLength;
          totalResources = resourceItemsLength;
          allResourcesLoaded = true;
          privateNS.$ajaxOverlay.hide();
        })
        .catch(function() {
          alert('There was an error getting all the resources');
        });

        ['.disciplines', '.diversities'].forEach(function(selector) {
          $(selector).change(function(e) {
            if (!allResourcesLoaded) {
              var $self = $(this);

              privateNS.waitABitAndThen(function() {
                $self.trigger('change');
              });
            } else {
              var $resourcesBuilder = $('<ul class="resources-list medium-block-grid-1 large-block-grid-2 xlarge-block-grid-3"></ul>'),
                disciplineVal = $disciplines.val(),
                diversityVal = $diversities.val();
              totalResources = 0;

              // Go through both lists.  If a value is selected in either list,
              // it must be part of the resource for it to be displayed.  Note we
              // use a detached DOM object to build this because otherwise each
              // append would refresh the DOM tree.  We need to build a DOM and not
              // just show and hide so the columns in the block grid work correctly.
              $allResources.find('li').each(function (i, el) {
                var $el = $(el),
                  elDisciplineVals = $el.attr('data-disciplines').split(','),
                  elDiversityVals = $el.attr('data-diversities').split(',');

                if ((disciplineVal === '' || elDisciplineVals.indexOf(disciplineVal) !== -1) &&
                    (diversityVal === '' || elDiversityVals.indexOf(diversityVal) !== -1)) {
                  var $newEl = $el.clone();
                  ++totalResources;

                  if (totalResources < 7) {
                    $newEl.show();
                  } else {
                    $newEl.hide();
                  }

                  $resourcesBuilder.append($newEl);
                }
              });

              // If we have at least six resources, show six and show the load more button.
              if (totalResources > 6) {
                $('.loadmore-resources-call-to-action-row').show();
                shownResources = 6;
              } else {
                $('.loadmore-resources-call-to-action-row').hide();
                shownResources = totalResources;
              }

              // Here is the one append to the real DOM.
              $resourcesContainer.html($resourcesBuilder);
            }
          });
        });

        $('.loadmore-resources').click(function(e) {
          if (!allResourcesLoaded) {
            var $self = $(this);

            privateNS.waitABitAndThen(function() {
              $self.trigger('click');
            }, 100);
          } else {
            var $this = $(this),
              newShown = shownResources + 6;

            $resourcesContainer.find('li').each(function (i, el) {
              if (i >= shownResources && i < newShown) {
                $(el).show();
                ++shownResources;
              }
            });

            if (shownResources < totalResources) {
              $this.parent().show();
            } else {
              $this.parent().hide();
            }
          }

          e.preventDefault();
        });
      }

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Initialize all of the blocks on the page
      Core.initBlocks(privateNS.$blocks);

      // Return the public namespace
      return publicNS;
    };

    /**
     * Waits a bit and then executes a function
     *
     * @param Function func
     */
    privateNS.waitABitAndThen = function(func) {
      privateNS.$ajaxOverlay.show();
      var $self = $(this);

      // Wait a bit and try again.
      setTimeout(func, 100);
    };

    /**
     * On page load try to select the default tab if it is define in the
     * url hash
     */
    privateNS.onPageLoad = function onPageLoad(event) {

      // If the page has a hash set, then try to select that tab by default
      if (window.location.hash !== '' &&
          window.location.hash !== '#') {

        // Switch the to tab define by the hash
        publicNS.switchTabs(
          privateNS.$tabControls,
          privateNS.$tabContents,
          window.location.hash.substr(1)
        );
      } else {

        // If there is not a hash defined tab to load, then the correct content
        // is already loaded. All that needs to be done is to update any
        // ancillary tab controls to their active / inactive states
        privateNS.updateTabControls(
          privateNS.$tabControls,
          privateNS.$tabContents.not('.hide').attr('data-tab-id')
        );
      }

      // Initialize slider blocks
      $('.hero-slider').each(function(i, el) {
        heroSlider({
          container: el
        });
      });
    };

    /**
     * Handles interactions with the tab controls on the page
     *
     * @param {Event} event The triggering event
     */
    privateNS.onClickTabControl = function onClickTabControl(event) {

      // Prevent the default action of triggering event
      event.preventDefault();

      // Get the triggering element
      var $target = $(this);

      // Extract the target tab id from the target
      var targetTabId = $target.attr('data-tab-target');

      // Toggle the states of the tab controls and content to the new tab
      publicNS.switchTabs(
        privateNS.$tabControls,
        privateNS.$tabContents,
        targetTabId
      );

      // Tab switching is synchronous so at this point the active tab should
      // now be visible. If the user is on a page with tabs on a mobile device,
      // scroll them down to the actual content of the page
      if ($.browser.mobile === true) {

        // Scroll the user down to the newly switched content
        $(window).scrollTop(
          privateNS.$tabContents.not('.hide').offset().top - Core.header.getHeight()
        );
      }
    };

    /**
     * Switches the active tab within a set of $tabs using the hide
     * class
     *
     * @param {jQuery} $tabControls The list of controls that control the tabs
     * @param {jQuery} $tabContents The list of tabs to manipulate
     * @param {string} tabId The id of the tab to switch to
     */
    publicNS.switchTabs = function($tabControls, $tabContents, tabId) {

      // Update the tab controls with the new active tab
      privateNS.updateTabControls($tabControls, tabId);

      // Look up a reference to the to be active tab content
      var $newlyActiveTabContent = $tabContents.filter(function filterById() {
        return $(this).attr('data-tab-id') === tabId;
      });

      // The tabId no longer is guaranteed to point to a sub-page, so check that
      // first
      if ($newlyActiveTabContent[0]) {

        // Hide all of the tab contents
        $tabContents.addClass('hide');

        // Show the newly active tab content
        $newlyActiveTabContent.removeClass('hide');

        // Scroll to tab into view
        Core.utils.goToElement($newlyActiveTabContent.offset().top - Core.header.getHeight() - Core.header.getSubHeaderHeight());

        // Update the hash url for the page to contain the url of the tab
        window.location.hash = tabId;
      }
    };

    /**
     * Switches the active tab controls within a set of tab controls
     *
     * @param {jQuery} $tabControls The list of controls that control the tabs
     * @param {string} tabId The id of the tab to switch to
     */
    privateNS.updateTabControls = function updateTabControls($tabControls, tabId) {

      // Look up a reference to the to be active tab control
      var $newlyActiveTabControl = $tabControls.filter(function filterByDataAttr() {
        return $(this).attr('data-tab-target') === tabId;
      });

      // Remove the active state from all of the tab controls
      $tabControls.removeClass('active');

      // Add the active state to the newly active tab control
      $newlyActiveTabControl.addClass('active');
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function() {

      // Attach the event handler for tab interactions
      privateNS.$tabControls.on(
        'click',
        privateNS.onClickTabControl
      );

      // Attach the event handler for the page loading
      $(window).on(
        'load',
        privateNS.onPageLoad
      );
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Page